/**
 * AI.GEN lines=1-60
 * 调度系统认证相关 API
 */
import { context } from '@/context';
import { Request } from '@/context/request';

const request: Request = context.request;
const host = '';

/**
 * 权限资源节点
 */
export interface IResource {
  code: string;
  name: string;
  children: IResource[];
}

/**
 * 用户信息响应数据
 */
export interface IInformation {
  /** 用户ID */
  userId: number | null;
  /** 用户名 */
  userName: string | null;
  /** 用户昵称 */
  userNick: string | null;
  /** 权限树 */
  resources: IResource[];
}

/**
 * 权限 code 常量
 */
export const PermissionCode = {
  HP_ORDER: 'd-dispatch-hporder',
  PF_ORDER: 'd-dispatch-pforder',
  UPDATE_WEATHER: 'd-dispatch-updateWeatherInfo',
} as const;

/**
 * 获取用户信息
 */
export const apiDispatchAuthInformation = async (): Promise<IInformation> => {
  return request.post(host + '/api/dispatch/auth/information', {});
};

/**
 * AI.GEN lines=1-1
 * 调度登出
 */
export const apiDispatchAuthLogout = async (): Promise<void> => {
  await request.post(host + '/api/dispatch/auth/logout', {});
};
